import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { Backdrop, ScriptService } from '../../../../service/script.service';
import { IconComponent } from "../../../icon/icon.component";

export interface BackdropDialogData {
  backdrop: Backdrop;
}

export interface BackdropDialogResult {
  backdrop: Backdrop;
}

@Component({
  selector: 'app-backdrop-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule
],
  templateUrl: './backdrop-dialog.component.html',
  styleUrl: './backdrop-dialog.component.less'
})
export class BackdropDialogComponent {
  form: FormGroup;
  availableBackdrops: Backdrop[] = [];
  
  selectedBackdrop: Backdrop | null = null;
  isZoomed: boolean = false;

  constructor(
    private fb: FormBuilder,
    private scriptService: ScriptService,
    public dialogRef: MatDialogRef<BackdropDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BackdropDialogData
  ) {
    this.form = this.fb.group({
      backdrop: [data.backdrop || null, Validators.required]
    });
    // Load from service
    this.availableBackdrops = this.scriptService.backdrops || [];
    this.selectedBackdrop = this.data.backdrop || null;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.form.valid) {
      const result: BackdropDialogResult = {
        backdrop: this.form.get('backdrop')?.value
      };
      this.dialogRef.close(result);
    }
  }

  onBackdropSelectionChange(event: MatSelectChange): void {
    this.selectedBackdrop = event.value;
    this.isZoomed = false; // Reset zoom when changing backdrop
  }

  onImageClick(event: Event): void {
    event.stopPropagation();
    this.isZoomed = !this.isZoomed;
  }

  onOverlayClick(): void {
    this.isZoomed = false;
  }
}
